import { render, staticRenderFns } from "./List.vue?vue&type=template&id=0389af42&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=0389af42&prod&scoped=true&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=0389af42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389af42",
  null
  
)

export default component.exports